import { Navigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'

interface PublicRouteProps {
  children: React.ReactNode
  redirectTo?: string
}

/**
 * Componente para proteger rutas públicas (login, register)
 * Redirige a usuarios autenticados a su dashboard correspondiente
 */
const PublicRoute = ({ children, redirectTo }: PublicRouteProps) => {
  const { user, loading, isStoreOwner, isPlatformAdmin, isDispatcher, isChef, isDelivery } = useAuth()

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Cargando...</p>
        </div>
      </div>
    )
  }

  // Si el usuario está autenticado, redirigir según su rol
  if (user) {
    // Si se especifica una ruta de redirección, usarla
    if (redirectTo) {
      return <Navigate to={redirectTo} replace />
    }

    // Redirigir según el rol del usuario
    if (isStoreOwner) {
      return <Navigate to="/store-owner/my-stores" replace />
    }
    if (isPlatformAdmin) {
      return <Navigate to="/admin/dashboard" replace />
    }
    if (isDispatcher || isChef || isDelivery) {
      return <Navigate to="/store/dashboard" replace />
    }
    // Clientes normales van al home
    return <Navigate to="/" replace />
  }

  // Si no está autenticado, mostrar el componente (login/register)
  return <>{children}</>
}

export default PublicRoute

